import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./styles.css";
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './ScrollToTop.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode is off so dev doesn’t mount/unmount/remount and run effects twice
// (e.g. History /all-logs would fire two identical requests). Re-enable if you want extra checks.
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <App />
  </BrowserRouter>
);

reportWebVitals();
